import React from 'react';
import { Paper } from '@mui/material';

const CustomPaper = ({ sx, children, ...rest }) => (
    <Paper
        sx={theme => ({
            borderRadius: '8px',
            padding: theme.spacing(2),
            minHeight: '450px',
            marginTop: theme.spacing(3),
            ...(typeof sx === 'function' ? sx(theme) : sx),
        })}
        elevation={2}
        {...rest}
    >
        {children}
    </Paper>
);

export default CustomPaper;
